export enum SchoolLevel {
Primary,
Middle,
High,
}
